export { LifetimeStatistics } from "./LifetimeStatistics";



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/LifetimeStatistics/index.js